import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import { Provider } from 'react-redux'
import Routes from 'src/Routes'
import { store } from './store/store'
import ErrorNotificationsProvider from './contexts/ErrorNotificationsContext'
import ErrorNotifications from './components/common/Notifications/ErrorNotifications'
import { BrowserRouter } from 'react-router-dom'

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <ConfigProvider
                theme={{
                    token: {
                        borderRadius: 4,
                        colorPrimary: '#4B286D',
                        colorPrimaryHover: '#331e50',
                        controlHeight: 32,
                        controlPaddingHorizontal: 12,
                        paddingContentHorizontal: 12,
                        colorText: '#2A2E2C',
                        colorTextHeading: '#414547',
                    },
                    components: {
                        Select: {
                            controlHeightLG: 40,
                        },
                        Table: {
                            rowHoverBg: '#F2EFF4',
                            rowSelectedBg: '#F2EFF4',
                            rowSelectedHoverBg: '#F2EFF4',
                            headerSplitColor: 'rgba(0,0,0,.06)',
                            headerBg: '#F4F4F7',
                            colorText: '#414547',
                        },
                        Input: {
                            paddingInline: 12,
                        },
                        Tag: {},
                        Button: {
                            defaultBorderColor: '#E3E6E8',
                            defaultBg: '#FFFFFF',
                            defaultHoverBg: '#F4F4F7',
                        },
                        Steps: {
                            navArrowColor: 'rgba(68, 84, 111, 0.25)',
                        },
                        Typography: {
                            titleMarginBottom: 0,
                            titleMarginTop: 0,
                        },
                        Pagination: {
                            borderRadius: 2,
                        },
                        Switch: {
                            colorTextQuaternary: '#B2B9BF',
                            colorTextTertiary: '#B2B9BF',
                        },
                        Collapse: {
                            contentPadding: '0px 0px',
                            colorText: '#2A2E2C',
                            colorTextHeading: '#2A2E2C',
                        },
                        Timeline: {
                            colorPrimary: '#dde0e5',
                            dotBorderWidth: 2,
                            itemPaddingBottom: 24,
                        },
                    },
                }}
            >
                <QueryClientProvider
                    client={
                        new QueryClient({
                            defaultOptions: {
                                queries: {
                                    refetchOnWindowFocus: false,
                                    staleTime: 30_000,
                                    retry: false,
                                },
                            },
                        })
                    }
                >
                    <ErrorNotificationsProvider>
                        <>
                            <BrowserRouter>
                                <Routes />
                            </BrowserRouter>
                            <ErrorNotifications />
                        </>
                    </ErrorNotificationsProvider>
                </QueryClientProvider>
            </ConfigProvider>
        </Provider>
    )
}

export default App
